import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr 1fr',
    columnGap: '20px',
    rowGap: '16px',
    color: zeplinColor.Neutral8,
  },
  content: { display: 'flex', alignItems: 'center', gap: '8px' },
  dotContainer: { padding: '7.5px' },
};
